import { convertDateToLocaleSpecific, localeDateFormats } from '../../../modules';

/** Formats an award expiration date using locale-specific numeric date patterns. */
export const formatWalletAwardNumericDate = (expirationDate: string, locale: string): string => {
  const localeKey = locale.replace('_', '-');
  const numericDateFormat =
    localeDateFormats[localeKey]?.numericDate ?? localeDateFormats['default']?.numericDate ?? 'MM/DD/YYYY';

  return convertDateToLocaleSpecific(expirationDate, locale, numericDateFormat) ?? expirationDate;
};
